// hooks/useDocument.js
import { useState, useCallback } from 'react';
import { documentApi } from '../api/documentApi';

export const useDocument = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getDocumentInfo = useCallback(async (docId) => {
    try {
      setLoading(true);
      setError(null);
      const response = await documentApi.getDocumentInfo(docId);
      return response;
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Помилка завантаження інформації про документ';
      setError(errorMsg);
      console.error('Error fetching document info:', err);
      throw new Error(errorMsg);
    } finally {
      setLoading(false);
    }
  }, []);

  const downloadDocumentFile = useCallback(async (docId, fileId, fileName) => {
    try {
      setLoading(true);
      setError(null);
      await documentApi.downloadDocumentFile(docId, fileId, fileName);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Помилка завантаження файлу';
      setError(errorMsg);
      console.error('Error downloading document file:', err);
      throw new Error(errorMsg);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    getDocumentInfo,
    downloadDocumentFile
  };
};